import { connect } from "react-redux";
import About3D from "../../components/project-pages/About3D";

export default connect(
  (state, props) => ({}),
  (dispatch, props) => ({})
)(About3D);
